import FrontEndApi from '../Globals/Scripts/FrontEndApi';

const loadProfile = async () => {
    const profile = await FrontEndApi.getWebApplicationProfile();
    return profile;
};

export default { loadProfile };
